import { PropsWithChildren, useEffect } from 'react';

type ModalProps = {
  isOpened: boolean;
  title?: string;
  showBack: boolean;
  backType?: 'close' | 'back';
  onClose: () => void;
};

export const Modal = ({
  isOpened,
  onClose,
  title,
  showBack = false,
  backType = 'close',
  children,
}: PropsWithChildren<ModalProps>) => {
  useEffect(() => {
    if (isOpened) {
      document.body.classList.add('modal-open'); // prevent bg scroll
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpened]);
  
  useEffect(() => {
    const closeOnEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    }
    document.addEventListener('keyup', closeOnEscape);
    return () => document.removeEventListener('keyup', closeOnEscape);
  }, [onClose]);

  if (!isOpened) return null;

  

  return (
    <div className="resourcespace-dialog">
      <div className="resourcespace-dialog-inner">
        <div className="resourcespace-dialog-header">
          {title && <h3 className="resourcespace-dialog-title">{title}</h3>}
          {showBack && (
            <button
              type="button"
              className="resourcespace-dialog-close-button"
              onClick={onClose}
            >
              {backType === 'close' ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16.482 16.482"
                >
                  <g fill="#0c1f72">
                    <path
                      d="M14.982 16.483a1.5 1.5 0 0 1-1.061-.439L.439 2.562a1.5 1.5 0 0 1 0-2.121 1.5 1.5 0 0 1 2.121 0l13.482 13.482a1.5 1.5 0 0 1 0 2.121 1.5 1.5 0 0 1-1.06.439Z"
                      data-name="Path 266"
                    />
                    <path
                      d="M1.5 16.483a1.5 1.5 0 0 1-1.061-.439 1.5 1.5 0 0 1 0-2.121L13.921.441a1.5 1.5 0 0 1 2.121 0 1.5 1.5 0 0 1 0 2.121L2.56 16.044a1.5 1.5 0 0 1-1.06.439Z"
                      data-name="Path 267"
                    />
                  </g>
                </svg>
              ) : (
                'Back'
              )}
            </button>
          )}
        </div>
        <div className="resourcespace-dialog-content">{children}</div>
      </div>
    </div>
  );
};
